<template>
    <div class="xc-pagination">
        <span class="xc-pagination-total">共 {{total}} 条</span>
        <span class="xc-pagination-size">
            每页
            <select
                class="xc-select"
                :value="size"
                @change="sizeChange"
            >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
            </select>
            条
        </span>
        <div class="xc-pagination-list">
            <a
                class="xc-pagination-item"
                v-if="page > 1"
                @click="change(page - 1)"
            >{{prevText}}</a>
            <a
                class="xc-pagination-item"
                v-if="page != 1"
                @click="change(1)"
            >{{fristText}}</a>
            <a
                class="xc-pagination-item"
                :class="page == item.number?'xc-pagination-item-active':''"
                v-for="(item,key) in indexs"
                :key="key"
                @click="change(item.number)"
            >
                {{item.number}}
            </a>
            <a
                class="xc-pagination-item"
                @click="change(lastPage)"
                v-if="page != lastPage && lastPage > 1"
            >{{lastText}}</a>
            <a
                class="xc-pagination-item"
                @click="change(page + 1)"
                v-if="page < lastPage"
            >{{nextText}}</a>
        </div>
        <div class="xc-pagination-go">
            前往
            <input
                type="text"
                :value="page"
                class="xc-input"
                @keyup.enter="go"
            >
            页
        </div>
    </div>
</template>


<script>
export default {
    name: 'XcPagination',
    props: {
        // 当前页数
        page: {
            default: 1
        },
        // 每页数量
        size: {
            default: 10
        },
        // 总条目数
        total: {
            type: Number,
            default: 1000,
        },
        // 分页按钮数量
        maxButtonCount: {
            default: 5,
        },
        prevText: {
            default: '上一页',
        },
        nextText: {
            default: '下一页',
        },
        fristText: {
            default: '首页',
        },
        lastText: {
            default: '尾页',
        },
    },
    data() {
        return {
            index: 0,
            lastPage: 0,
        }
    },
    updated() {

    },
    watch: {
        // page(val) {
        //     this.index = val || 1
        // },

    },
    computed: {
        indexs() {
            let { maxPage, total, size, maxButtonCount, page } = this;

            // 中间页数
            const middlePage = parseInt(this.maxButtonCount / 2);

            if (maxPage == undefined) {
                // 总分页数
                maxPage = parseInt(total / size);

                if (maxPage == 0 || parseInt(total % size)) {
                    maxPage++;
                }
            }

            let startIndex = Math.max(1, page - middlePage);
            let endIndex = page + middlePage;

            // 开始页不能小于1
            if (startIndex > maxPage - maxButtonCount + 1 && maxPage - maxButtonCount + 1 > 0) {
                startIndex = maxPage - maxButtonCount + 1;
            }

            if (maxButtonCount > endIndex) {
                endIndex = maxButtonCount;
            }

            // 结束页不能大于最大页数
            if (endIndex > maxPage) {
                endIndex = maxPage;
            }

            const indexs = []
            for (let i = startIndex; i <= endIndex; i++) {
                const data = {
                    number: i
                }

                indexs.push(data)
            }

            this.lastPage = maxPage;

            return indexs;
        }
    },
    methods: {
        sizeChange(e) {
            this.$emit('change', this.page, e.target.value);
        },
        change(page) {
            this.$emit('change', page, this.size);
        },
        go(e) {
            const page = e.target.value;
            if(Number(page)){
                if (page > this.lastPage) {
                    return this.$message.error(`不能超过${this.lastPage}页`);
                }
            }else{
                return this.$message.error(`请输入正确的页数`);
            }

            this.$emit('change', Number(page), this.size);
        }
    },
}
</script>

<style scoped lang="scss">
// @import "../scss/variable";
// @import "../scss/pagination";
</style>

